import { IS_AUTHENTICATED, IS_AUTHENTICATED_SUCCESS, LOGOUT, RESET_AUTH_STATE, USER_INFO, USER_INFO_SUCCESS } from "./actionsType";



export const isAuthenticatedAction = () => ({
    type: IS_AUTHENTICATED,
})
export const isAuthenticatedActionSuccess = (payload) => ({
    type: IS_AUTHENTICATED_SUCCESS,
    payload
})

export const logoutAction = () => ({
    type: LOGOUT
})

export const userInfoAction = () => ({
    type: USER_INFO,
})
export const userInfoActionSuccess = (payload) => ({
    type: USER_INFO_SUCCESS,
    payload
})

export const resetAuthStateAction = () => ({
    type: RESET_AUTH_STATE
})
